var CourseClass = {
    init: function (){
        this.initActions()
        this.coursePagination($('.course-list'), $('.btn-load-course-more'))
    },
    coursePagination: function ($container, $paginateButton) {
        if (!$paginateButton.length && !$container.length) return;
        let stopped = false;
        let url = $paginateButton.attr('data-url');
        let autoLoading = $paginateButton.attr('data-auto-loading');
        let paginateButtonText = $paginateButton.html();
        let paginateButtonLoadingText = $paginateButton.attr('data-loading-text');

        let isMasonry = $container.hasClass('masonry');
        if (isMasonry) Common.masonryLazy($container);
        let itemClass = isMasonry ? 'masonry-item' : 'course-gird';

        function renderCourse(course) {
            let html = course.html;
            if (isMasonry) html = html.replaceAll('img-responsive lazyload', 'img-responsive masonry-lazy')
            return `<div class="col-md-4 mb-4 ${itemClass}">${html}</div>`
        }

        function render() {
            Common.buttonLoading($paginateButton, paginateButtonLoadingText);

            let page = 1;
            if ($paginateButton.attr('data-page') != undefined) {
                page = parseInt($paginateButton.attr('data-page'))
            }
            $.ajax({
                type: 'GET',
                url: url,
                data: {page: page + 1},
                dataType: 'json',
                success: function (resp) {
                    $paginateButton.attr('data-page', resp.current_page);
                    if (resp.current_page >= resp.last_page) {
                        let btnExtend = $paginateButton.attr('data-btn_extend');
                        if (btnExtend){
                            $paginateButton.parent().append(btnExtend);
                        }

                        $paginateButton.fadeOut();
                        stopped = true;
                    }
                    let items = resp.data;
                    if (items.length > 0) {
                        let html = '';
                        for (let i = 0; i < items.length; i++) {
                            let item = items[i];
                            html += renderCourse(item);
                        }
                        let $el = $(html);
                        if (isMasonry) {
                            $container.append($el).masonry('appended', $el);
                        } else {
                            $container.append($el);
                        }
                    }

                },
                error: function (err) {
                    $paginateButton.fadeOut();
                    stopped = true;
                },
                complete: function (data) {
                    $paginateButton.attr('data-page', page + 1);
                    $paginateButton.attr('data-loading', 0);
                    Common.buttonReset($paginateButton, paginateButtonText);
                    if (isMasonry) {
                        Common.masonryLazy($container);
                    } else {
                        Common.lazyload();
                    }
                }
            });
        }

        if (autoLoading) {
            $(window).scroll(function () {
                if ($(window).scrollTop() + $(window).height() >= $container.height()) {
                    if (stopped == true) {
                        return false;
                    }
                    let loading = parseInt($paginateButton.attr('data-loading'));
                    if (loading == 0) {
                        $paginateButton.attr('data-loading', 1);
                        render()
                    }
                }
            });
        }
        $paginateButton.on('click', function (e) {
            e.preventDefault();
            var loading = parseInt($paginateButton.attr('data-loading'));
            if (loading == 0) {
                $paginateButton.attr('data-loading', 1);
                render();
            }
        });
    },
    initActions: function (){
        $(document).on("click", "a.__btn-view-lesson", function (e) {
            //stop submitting the form to see the disabled button effect
            // e.preventDefault();

            let text = $(this).html();
            $(this).addClass("disabled");

            //disable the submit button
            Common.buttonLoading($(this), text)

            return true;
        });
    }
}

$(document).ready(function () {
    CourseClass.init();
});
